import { Component, OnInit, Input } from '@angular/core';
import { TabComponent } from '../tab-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-loan-wheel-inventory',
  templateUrl: './loan-wheel-inventory.component.html',
  styleUrls: ['./loan-wheel-inventory.component.scss']
})
export class LoanWheelInventoryComponent implements OnInit, TabComponent {
  @Input() data: any;
  supplierCode: string;

  constructor(
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activedRoute.parent.params.subscribe(params => this.supplierCode = params['code']);
  }

  isDirty(): boolean {
    return false;
  }

  save() {

  }
}
